import React, { useState, useEffect } from "react";
import { Button, NewInput } from "components/atomes";

const PersonalInfos = ({
  className = "card--signUp",
  values,
  setValues,
  setFormState,
}) => {
  const [error, setError] = useState({
    phone: { visible: false, message: "" },
  });

  useEffect(() => {
    if (values.phone.length !== 10) {
      setError(s => ({
        ...s,
        phone: {
          visible: true,
          message: "يجب أن يكون عدد الأرقام 10, تأكد من رقم الهاتف",
        },
      }));
    } else if (isNaN(parseInt(values.phone))) {
      setError(s => ({
        ...s,
        phone: {
          visible: true,
          message: "يجب أن يتكون رقم الهاتف من أعداد فقط",
        },
      }));
    } else {
      setError(s => ({
        ...s,
        phone: {
          visible: false,
          message: "",
        },
      }));
    }
  }, [values.phone]);
  return (
    <>
      <h3>معلومات شخصية</h3>
      <div className={className}>
        <h3>اللقب</h3>
        <NewInput
          type="text"
          value={values.lastName}
          name="lastName"
          setValue={setValues}
          placeholder="اللقب"
        />
        <h3>الاسم</h3>
        <NewInput
          type="text"
          value={values.firstName}
          name="firstName"
          setValue={setValues}
          placeholder="الاسم"
        />
        <h3>رقم الهاتف</h3>
        <NewInput
          type="text"
          value={values.phone}
          name="phone"
          setValue={setValues}
          placeholder="رقم الهاتف"
        />
        {error.phone.visible && (
          <p style={{ color: "red" }}>{error.phone.message}</p>
        )}
        <Button
          type="primary"
          handelClick={() => setFormState("signup")}
          isDisabled={values.day === "" ? false : values.phone === ""}
        >
          {values.phone === "" || values.day === "" ? "لاحقا" : "سجل"}
        </Button>
      </div>
    </>
  );
};

export default PersonalInfos;
